import { Helmet } from "react-helmet-async"
import { HotelOtaBookings } from "../../../../HotelOtaBookings"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function OrganizationOtaBookingsPage() {
	return (
		<>
			<Helmet>
				<title>OTA Bookings | Org</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_HOTEL_BOOKINGS}>
				<HotelOtaBookings />
			</ForbidUnlessAuthorized>
		</>
	)
}
